import styled from 'styled-components';

export const Paper = styled.div`
  &&&& {
    position: relative;
    max-width: 600px;
    margin: 40px auto 20px;
    background-color: #f0f2f5;
    border: 3px solid #d9e1e8;
    border-radius: 9px;
    color: #4f708e;
    box-shadow: 0px 3px 3px -2px rgb(0 0 0 / 20%),
      0px 3px 4px 0px rgb(0 0 0 / 14%), 0px 1px 8px 0px rgb(0 0 0 / 12%);
    @media (max-width: 600px) {
      width: 100%;
    }
  }
`;

export const MainTitle = styled.span`
  &&&& {
    position: absolute;
    left: 50%;
    top: 0;
    background: #d9e1e8;
    box-shadow: 0 1px 2px rgb(0 0 0 / 20%);
    border-radius: 5px;
    width: 162px;
    text-align: center;
    font-weight: 600;
    font-size: 18px;
    line-height: 21px;
    color: #4f708e;
    padding: 12px 0;
    transform: translate(-50%, -50%);
  }
`;

export const Hr = styled.hr`
  &&& {
    border: none;
    color: #d9e1e8;
    background-color: #d9e1e8;
    height: 2px;
    margin: 20px 0;
  }
`;

export const MainCalc = styled.div`
  &&& {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    flex-wrap: wrap;
  }
`;

export const MainCalWrapper = styled.div`
  &&& {
    padding: 20px;
    margin-top: 15px;
  }
`;

export const MainLabel = styled.label`
  &&& {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-size: 18px;
    margin-right: 0;
    @media (max-width: 500px) {
      font-size: 16;
    }
    @media (max-width: 320px) {
      font-size: 22px;
    }
  }
`;

export const MainInput = styled.input`
  &&&& {
    background-color: #fff;
    border: 1px solid rgba(72, 76, 82, 0.14);
    border-radius: 6px;
    color: #7f8286;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    margin: 5px;
    padding: 10px;
    text-align: center;
    width: 70px;
    &::-webkit-inner-spin-button,
    &::-webkit-outer-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    @media (max-width: 500px) {
      width: 45px;
    }
    @media (max-width: 320px) {
      width: 40px;
    }
  }
`;

export const MainSelect = styled.select`
  &&& {
    display: block;
    font-size: 1rem;
    background-color: #fdfdfd;
    border: 1px solid #e1e1e1;
    border-radius: 5px;
    cursor: pointer;
    height: 46px;
    overflow: hidden;
    padding: 0 10px 0 5px;
    transition: border-color 0.3s;
    @media (max-width: 500px) {
      padding: 0 5px 0 2px;
    }
  }
`;

export const MainActions = styled.div`
  &&& {
    margin-top: 25px;
    display: flex;
    justify-content: center;
    column-gap: 20px;
    button {
      cursor: pointer;
      text-align: center;
      padding: 1em 2em;
      border: none;
      outline: none;
      border-radius: 5px;
      transition: 0.2s;
      &:nth-child(1) {
        background: #f9d12f;
        :hover {
          background-color: #f8cc16;
        }
        :active {
          background-color: #d5ac06;
        }
      }
      &:nth-child(2) {
        background: #ccc;
        &:hover {
          background-color: #bfbfbf;
        }
        &:active {
          background-color: #a6a6a6;
        }
      }
    }
  }
`;

export const CopyButton = styled.button`
  &&& {
    display: block;
    margin: 0 auto;
    background: none;
    border: none;
    cursor: pointer;
    color: #4f708e;
    padding: 0.8em 1.5em;
    text-decoration: underline dotted;
    &:hover {
      background: rgba(0, 0, 0, 0.1);
      border-radius: 5px;
    }
  }
`;

export const MainCircle = styled.div`
  &&& {
    position: relative;
    width: 150px;
    height: 150px;
    border: 4px solid #777777;
    border-radius: 50%;
    @media (max-width: 500px) {
      width: 100px;
      height: 100px;
    }
  }
`;

export const SolutionWrapper = styled.div`
  &&& {
    padding: 20px;
    border-top-left-radius: 15px;
    border-top-right-radius: 15px;
    box-shadow: 0 -2px 4px rgba(0, 0, 0, 0.33);
  }
`;
export const CalcSolution = styled.div`
  &&& {
    margin-top: 15px;
    border-radius: 15px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.33);
    padding: 20px;
    overflow-x: auto;

    @media (max-width: 500px) {
      font-size: 14px;
    }
    @media (max-width: 320px) {
      font-size: 12px;
    }
  }
`;
export const Parag = styled.p`
  padding: 0;
  margin: 25px 0 10px;
  font-size: 1.2rem;
`;
export const MainFlex = styled.div`
  &&& {
    @media (max-width: 500px) {
      display: flex;
      width: 100%;
      justify-content: space-between;
      align-items: center;
    }
  }
`;
